<template>
  <vue-slider
    v-model="value"
    :data="computedData"
    :marks="computedMarks"
    :contained="false"
    :enable-cross="false"
    @dragging="value => onDragging(value)"
    @change="value => onChange(value)"
  >
    <template v-slot:process="{ start, end, style }">
      <div class="vue-slider-process custom-class" :style="style">
        <div class="vue-slider-range-tooltip">{{formatDate(value[0])}} - {{formatDate(value[1])}}</div>
      </div>
    </template>

    <template v-slot:label="{ active, value }">
      <div :class="['vue-slider-mark-label', 'custom-label', { active }]">{{ formartMark(value) }}</div>
    </template>
  </vue-slider>
</template>
<script>
// App.vue
import VueSlider from "vue-slider-component";
import "../assets/scss/slider.css";
import moment from "moment";

export default {
  name: "slider",
  props: {
    min: {
      type: String,
      default: "11/1/2013"
    },
    max: {
      type: String,
      default: "11/1/2016"
    },
    data: {
      type: Array,
      default: () => [0, 100]
    },
    onDragging: {
      type: Function,
      default: () => null
    },
    onDragEnd: {
      type: Function,
      default: () => null
    },
    onChange: {
      type: Function,
      default: () => null
    }
  },
  computed: {
    computedData: function() {
      let data = this.data;
      let [min, max] = this.getMaxMinDates(data);
      let minMoment = moment(new Date(min)).startOf("year");
      let maxMoment = moment(new Date(moment().format("MM/1/YYYY"))).endOf(
        "month"
      );
      // while max - min >= 0 months
      // add minMoment to timeline and add 1 month to minMoment
      let timeline = [];
      while (maxMoment.diff(minMoment, "months") >= 0) {
        timeline.push(minMoment.format("M/D/YYYY"));
        minMoment.add(1, "month");
      }
      return timeline;
    },
    computedMarks: function() {
      return this.computedData.filter(
        date => date.startsWith("1/") || date.startsWith("6/")
      );
    }
  },
  methods: {
    isMark: date => {
      let dateObj = new Date(date);
      return dateObj.getMonth() == 0 || dateObj.getMonth() == 5;
    },
    formatDate: date => {
      let d = new Date(date);
      return `${d.getMonth() + 1}/${d.getFullYear()}`;
    },
    formartMark: date => {
      return date.replace("/1/", "/");
    },
    getMaxMinDates: dates => {
      let sorted = (window.sorted = dates.sort(function(a, b) {
        return new Date(b.date) - new Date(a.date);
      }));
      return [sorted[0], sorted[sorted.length - 1]];
    }
  },
  mounted() {
    console.log("<Slider> mounted. see window.slider");
    window.slider = {
      data: this.data,
      minMax: this.getMaxMinDates(this.data),
      formatDate: this.formatDate
    };
  },
  data: function() {
    return {
      value: [this.min, this.max]
    };
  },
  components: {
    VueSlider,
    moment
  }
};
</script>

<style lang="css" scoped>
.vue-slider {
  margin-top: 0px;
}

.vue-slider-mark-label.custom-label {
  font-size: 12px;
  color: #29ff10;
  transform: translate(-2px, -2px);
}

@media screen and (max-width: 760px) {
  .vue-slider-ltr .vue-slider-mark {
    display: none;
  }
  .vue-slider-mark-label {
    display: none;
  }
}
</style>
